import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import {DialogContentText} from "@mui/material";
import Typography from "@mui/material/Typography";

export default function SecretSantaBecameConsentDialog(props) {

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            scroll={'paper'}
        >
            <DialogTitle>{"Secret Santa participation confirmation"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography variant="h6">
                        Please confirm that:
                    </Typography>
                    <Typography variant="h6">
                        * You want to participate in Secret Santa
                    </Typography>
                    <Typography variant="h6">
                        * You will have to come to the selected office at least twice: to bring the present and to collect it
                    </Typography>

                </DialogContentText>

            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose} color="primary">
                    Close
                </Button>
                <Button
                    onClick={props.handleApprove}
                    variant="contained"
                    color="success"
                    autoFocus
                >
                    Make me the Secret Santa!
                </Button>
            </DialogActions>
        </Dialog>
    );
}
